import styles from './styles.module.css'

export default function SkeletonGrid({count = 9}){
    //create an array of size count
    return(
        <div className={styles.SkeletonGrid}>
            {Array.from({length: count }).map((_, i) => (
                <div key={i} className={styles.SkeletonBox} />
            ))}
        </div>
    )
}